module.exports = __webpack_public_path__ + "static/img/232.c925109.png";